module.exports = __webpack_public_path__ + "img/how-it-works-2.2317a460.svg";